import { motion, AnimatePresence } from "framer-motion";
import { ClickableElement } from "@rapid/components/ClickableElement";
import { useShareWorkflow } from "@rapid/hooks/useShareWorkflow";

export const ShareButton = () => {
    // Use shared share workflow hook
    const { shareUrl, copied, handleShare } = useShareWorkflow();

    if (!shareUrl) {
        // Don't show share button if no URL available
        return null;
    }

    return (
        <div className="relative">
            <ClickableElement
                icon={copied ? "fas fa-check" : "fas fa-arrow-up-from-square"}
                title={copied ? "Link Copied!" : "Share My Model"}
                onClick={handleShare}
                isSelected={false}
                disabled={false}
            />

            {/* Tooltip showing the URL when copied */}
            <AnimatePresence>
                {copied && (
                    <motion.div
                        initial={{ opacity: 0, y: -5 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -5 }}
                        className="absolute bottom-full left-0 right-0 z-10 mb-2 rounded-md bg-gray-900 p-2 text-xs text-white shadow-lg"
                    >
                        <div className="truncate">{shareUrl}</div>
                        <div className="absolute bottom-0 left-1/2 h-2 w-2 -translate-x-1/2 translate-y-1/2 rotate-45 transform bg-gray-900"></div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};
